export class SWIC11IndividualLeaderboard {
    constructor(leaderboard) {
        this.$leaderboard = $(leaderboard);
        this.$allBtn = this.$leaderboard.find('#all');
        this.$myChainBtn = this.$leaderboard.find('#mine');
        this.$allBoard = this.$leaderboard.find('.swic11-ind-leaderboard').eq(0);
        this.$myChainBoard = this.$leaderboard.find('.swic11-ind-leaderboard').eq(1);
        let allRank = this.$allBoard.attr("data-my-rank");
        let myChainRank = this.$myChainBoard.attr("data-my-rank");
        const self = this;
        $('#swic11-rank').html(allRank);
        this.$myChainBtn.on('click', () => {
            self.$allBoard.hide();
            self.$myChainBoard.show();
            $('#swic11-rank').html(myChainRank);
        });
        this.$allBtn.on('click', () => {
            self.$allBoard.show();
            self.$myChainBoard.hide();
            $('#swic11-rank').html(allRank);
        });
    }
}
const c = {};
$(".swic11-individual-leaderboard").each((i, elem) => {
    c[i] = new SWIC11IndividualLeaderboard(elem);
});
